/** Izvuci mount ID iz Zeno stream URL-a za Metadata API */
export function getZenoMountId(streamUrl: string): string | null {
  try {
    const url = new URL(streamUrl);
    if (!url.hostname.includes('zeno.fm')) return null;
    const path = url.pathname.replace(/^\/+/, '').split('/')[0];
    return path || null;
  } catch {
    return null;
  }
}

/** Je li stream Zeno.fm? */
export function isZenoStream(streamUrl: string): boolean {
  return getZenoMountId(streamUrl) !== null;
}
